import { z } from 'zod';

export const zodMoveCompanyPathSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('companies'),
  z.uuid(),
  z.literal('move'),
]);

export const zodMoveCompanyPayloadSchema = z.object({
  targetCompanyAccountId: z.uuid(),
});
